import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

interface CreateDocuSealSubmissionParams {
  referentData: {
    id: string;
    name: string;
    email: string;
  };
  campaignId: string;
}

interface DocuSealSubmissionResponse {
  success: boolean;
  submissionId: string;
  embeddingUrl: string;
  message: string;
}

export const useCreateDocuSealSubmission = () => {
  return useMutation({
    mutationFn: async ({ referentData, campaignId }: CreateDocuSealSubmissionParams): Promise<DocuSealSubmissionResponse> => {
      console.log('Création submission DocuSeal avec:', { referentData, campaignId });
      
      const { data, error } = await supabase.functions.invoke('create-docuseal-submission', {
        body: {
          referentData,
          campaignId
        }
      });

      console.log('Réponse DocuSeal:', { data, error });

      if (error) {
        console.error('Erreur Supabase:', error);
        throw error;
      }

      if (!data?.success) {
        throw new Error(data?.error || 'Erreur lors de la création du document');
      }

      return {
        success: data.success,
        submissionId: data.submissionId,
        embeddingUrl: data.embeddingUrl,
        message: data.message
      };
    },
    onError: (error: any) => {
      console.error('Erreur de signature:', error);
      
      let errorMessage = "Impossible de créer le document de signature. Veuillez réessayer.";
      
      if (error.message?.includes('template')) {
        errorMessage = "Template DocuSeal non configuré. Veuillez contacter le support.";
      } else if (error.message?.includes('API')) {
        errorMessage = "Erreur d'authentification avec DocuSeal.";
      } else if (error.message?.includes('Failed to fetch')) {
        errorMessage = "Problème de connexion avec DocuSeal. Veuillez réessayer.";
      }
      
      toast.error('Erreur de signature', {
        description: errorMessage,
      });
    }
  });
};